<template>
  <v-card flat>
    <v-card-title class="subheader py-0">
      <v-icon small class="mr-1" color="indigo">view_list</v-icon>
      更新入库数据
      <v-spacer/>

      <v-btn
        flat round color="primary" dark
        :disabled="!funcIds.includes('u_inteApp')"
        @click.native.stop="
             () => {
                  editDbid = item.dbid;
                  edit = true;
                }">
        <v-icon>edit</v-icon>
        更新入库数据
      </v-btn>

    </v-card-title>
    <v-divider color="indigo"/>
    <v-card-text class="pt-0">
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs4>
            <div class="x-text-field">
              <label>申请号/登记号</label>
              <div>{{item.number}}</div>
            </div>
          </v-flex>
          <v-flex xs4>
            <div class="x-text-field">
              <label>申请日期</label>
              <div>{{item.appDate}}</div>
            </div>
          </v-flex>
          <v-flex xs4>
            <div class="x-text-field">
              <label>代理人员</label>
              <div>{{!item.agent? "" : item.agent.name}}</div>
            </div>
          </v-flex>
          <v-flex xs4>
            <div class="x-text-field">
              <label>流程状态</label>
              <div>{{!item.processState? "" : item.processState.name}}</div>
            </div>
          </v-flex>
          <v-flex xs4>
            <div class="x-text-field">
              <label>流程状态日期</label>
              <div>{{item.processStateDate}}</div>
            </div>
          </v-flex>
          <v-flex xs4>
            <div class="x-text-field">
              <label>成果状态</label>
              <div>{{!item.outcomeState? "" : item.outcomeState.name}}</div>
            </div>
          </v-flex>
          <v-flex xs12>
            <div class="x-text-field">
              <label>备注</label>
              <div>{{item.notes}}</div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>

    <x-edit
      v-model="edit"
      :dbid="editDbid"
      v-on:ok="onEditOk"
    />

  </v-card>
</template>
<script>
  import {mapGetters} from 'vuex'
  import XEdit from './edit'

  export default {
    components: {XEdit},
    props: {
      inteApp: Object
    },
    data: () => ({
      item: {},
      edit: false,
      editDbid: null,
    }),

    watch: {
      inteApp(v) {
        if (v) this.item = v;
      }
    },
    computed: {
      ...mapGetters(['funcIds'])
    },

    methods: {
      onEditOk(v) {
        if (v) {
          this.item = window.xutil.clone(v);
          this.$emit("ok", this.item);
        }
      }
    }
  }
</script>
